module.exports = __webpack_public_path__ + "static/media/icon-checkmark-checked.c6189319.svg";